import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            动漫分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            按类型浏览动漫大全，快速找到你喜欢的动漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                cat.color === 'primary'
                  ? 'bg-primary-100 text-primary-500'
                  : cat.color === 'accent'
                  ? 'bg-accent-100 text-accent-500'
                  : 'bg-secondary-100 text-secondary-500'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}